export default __webpack_public_path__ + "static/media/rocket_anim_87.21fd953c.png";